import {POST} from "@/services/gateway";

const listItems = ({pagination, userIds, snapshotDateTime, folderId, searchTerm}) => {
  return POST('google/task/search', {pagination, userIds, snapshotDateTime, folderId, searchTerm});
}

const listTaskBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('google/task/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  return POST('google/task/export', {snapshotDateTime, sourceIds, searchTerm, selectedIds}, {code: code ? code : null})
}

const restoreSnapshot = ({snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds, code}) => {
  return POST('google/task/restore', {snapshotDateTime, sourceIds, searchTerm, destinationId, snapshotId, selectedIds}, {code: code ? code : null})
}

export {
  listItems,
  listTaskBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
